import apicaller from "@/utils/apicaller";
import api from "../main.api";
export default {
    all(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.all, payload)
    },
    rules(id) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.rules}/${id}`)
    },
    getMatchedRuleSets(id) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.matchedRuleSets}/${id}`)
    },
    getQueriedRuleSets(id) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.queriedRuleSets}/${id}`)
    },
    callRestService(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.restService, payload)
    },
    getIncidentWithInputData(id) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.incidentWithInputData}/${id}`)
    },
    preparedToIncident(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.preparedToIncident, payload);
    },
    execute(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.execute, payload);
    },
    assigneeUpdate(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.assignee, payload);
    },
    statusUpdate(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.status, payload);
    },
    detail(id) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.detail}/${id}`)
    },
    entityServiceActions(serviceEntityId) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.entityServiceActions}/${serviceEntityId}`)
    },
    getHistory(incidentId) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.history}/${incidentId}`);
    },
    saveAttachments(formData) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.attachment, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    },
    getAttachments(incidentId) {
        return apicaller.get(`${api.FRAUDINCIDENTMANAGEMENT.attachment}/${incidentId}`);
    },
    deleteAttachments(attachments) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.bulkDeleteAttachment, attachments);
    },
    downloadDocument(attachment) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.singleAttachmentDownload, attachment, { responseType: "blob" });
    },
    downloadMultiDocument(attachments) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.multiAttachmentDownload, attachments, { responseType: "blob" });
    },
    logServiceActions(payload) {
        return apicaller.post(api.FRAUDINCIDENTMANAGEMENT.logServiceActions, payload);
    }
}